import React, { useMemo, useState } from "react";
// import styled from "styled-components";
import { DEFAULT_PORT_ICON } from "../../../constants";

// const PortDefaultOuter = styled.div({});

function PortCustom(props) {
  const [color, setColor] = useState("white");
  const design = useMemo(() => {
    let d = DEFAULT_PORT_ICON;
    if (props.port.properties) {
      const { design } = props.port.properties;
      if (design) {
        d = design;
      }
    }
    return d;
  }, [props]);
  return (
    <div
      style={{
        width: props.port.width || "15px",
        height: props.port.height || "15px",
        borderRadius: "50%",
        background: "#5cb85c",
        border: "2px solid grey",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      onMouseEnter={() => setColor("grey")}
      onMouseLeave={() => setColor("white")}
    >
      <svg
        style={{
          width: props.port.width || "24px",
          height: props.port.height || "24px",
        }}
        viewBox={props.port.viewBox || "0 0 24 24"}
      >
        <path fill={color} d={design} />
      </svg>
    </div>
  );
}

export default PortCustom;
